import { set } from 'cerebral/operators'

export default [
  set('state:app.showAlreadyAgreedGDPRTerms', true),
  set('state:login.showGDPRDialog', true)
]



// WEBPACK FOOTER //
// ./src/modules/app/chains/showGDPRAgreement.js